import React from 'react'

interface UsePropertyControlsArgs {
  fullscreenConfig: boolean
  isFullscreenActive: boolean
  disableToggle?: boolean
}

const INITIAL_VALUES = {
  showControlsInForcedFullscreen: true,
}

const usePropertyControls = ({
  fullscreenConfig,
  isFullscreenActive,
  disableToggle,
}: UsePropertyControlsArgs) => {
  const forcedFullscreenIsActive = fullscreenConfig && isFullscreenActive
  const [showControlsInForcedFullscreen, setShowControlsInForcedFullscreen] =
    React.useState(INITIAL_VALUES.showControlsInForcedFullscreen)

  const reset = React.useCallback(() => {
    setShowControlsInForcedFullscreen(
      INITIAL_VALUES.showControlsInForcedFullscreen
    )
  }, [])

  React.useEffect(() => {
    if (disableToggle) {
      return undefined
    }
    if (!forcedFullscreenIsActive) {
      reset()
      return undefined
    }

    const handleToggleControlsInForcedFullscreen = () => {
      setShowControlsInForcedFullscreen((prevVal) => !prevVal)
    }

    const timeoutId = setTimeout(
      () =>
        document.addEventListener(
          'click',
          handleToggleControlsInForcedFullscreen
        ),
      0
    )

    return () => {
      clearTimeout(timeoutId)
      document.removeEventListener(
        'click',
        handleToggleControlsInForcedFullscreen
      )
    }
  }, [forcedFullscreenIsActive, reset, disableToggle])

  return React.useMemo(
    () => ({
      forcedFullscreenIsActive,
      showControlsInForcedFullscreen,
      reset,
    }),
    [forcedFullscreenIsActive, showControlsInForcedFullscreen, reset]
  )
}

export default usePropertyControls
